import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Loading } from './Loading';
import { PageSelector } from './PageSelector';
import * as S from './styles';
import { Row, Col, Skeleton } from 'antd';
import { Text } from '@/components/Typography';

interface PaginationStyledProps {
	loading: boolean;
	page: number;
	maxPage: number;
	total?: number;
	setMaxPage?: (size: number) => void;
	setPage: (size: number) => void;
}

type SelectOption = {
	value: number;
	label: string;
};

/* Deprecated */
export const PaginationCustom: React.FC<PaginationStyledProps> = ({
	page,
	total,
	loading,
	maxPage,
	setMaxPage,
	setPage
}) => {
	const selectOptions: SelectOption[] = [5, 10, 20, 30, 50, 100, 200].map((option) => ({
		label: `${option}`,
		value: option
	}));

	const handleChange = (value: any) => {
		if (setMaxPage) {
			setMaxPage(value);
		}
		setPage(1);
	};

	return (
		<>
			{loading ? (
				<Row justify="space-between" style={{ marginTop: '1rem', padding: '0 1rem' }}>
					<Col>
						<Skeleton.Input active />
					</Col>
					<Col>
						<Skeleton.Input active />
					</Col>
				</Row>
			) : (
				<Row justify="space-between" style={{ marginTop: '1rem', padding: '0 1rem' }}>
					<Col>
						{setMaxPage && (
							<>
								<Text>{I18n.get('Items per page')}</Text>
								<S.SelectWrapper
									defaultValue={maxPage}
									options={selectOptions}
									onChange={handleChange}
								/>
							</>
						)}
					</Col>
					<Col>
						<S.PaginationWrapper
							hideOnSinglePage={false}
							showSizeChanger={false}
							total={total}
							current={page === 0 ? page + 1 : page}
							pageSize={maxPage}
							onChange={(page) => {
								setPage(page);
							}}
						/>
					</Col>
				</Row>
			)}
		</>
	);
};

interface PaginationProps {
	loading?: boolean;
	limit?: number;
	page?: number;
	total?: number;
	onSetLimit: (value: number) => void;
	onSetPage: (value: number) => void;
}

export const Pagination = ({
	loading = true,
	limit = 0,
	page = 0,
	total = 0,
	onSetLimit,
	onSetPage
}: Readonly<PaginationProps>) => {
	const currentPage: number = page === 0 ? page + 1 : page;

	function handleGetCurrentCount(): number {
		if (total < limit) return total;

		return limit;
	}

	return (
		<Row justify="space-between" align="middle">
			<Col>
				<Row align="middle" gutter={[20, 0]}>
					<Col>
						<Loading active={loading}>
							<PageSelector defaultValue={limit} onChange={onSetLimit} />
						</Loading>
					</Col>
					<Col>
						<span>
							{I18n.get('Displaying')} {handleGetCurrentCount()} {I18n.get('of')} {total}
						</span>
					</Col>
				</Row>
			</Col>
			<Col>
				<Loading active={loading}>
					<S.PaginationWrapper
						total={total}
						pageSize={limit}
						current={currentPage}
						hideOnSinglePage={false}
						showSizeChanger={false}
						onChange={onSetPage}
					/>
				</Loading>
			</Col>
		</Row>
	);
};
